exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*拖拽区div样式*/\n.resize[data-v-75b93a00] {\n  cursor: col-resize;\n  position: relative;\n  top: 250px;\n  background-color: #d6d6d6;\n  border-radius: 5px;\n  margin-top: -10px;\n  width: 12px;\n  height: 60px;\n  line-height: 60px;\n  background-size: cover;\n  background-position: center;\n  /*z-index: 99999;*/\n  font-size: 32px;\n  color: white;\n  text-align: center;\n}\n\n/*拖拽区鼠标悬停样式*/\n.resize[data-v-75b93a00]:hover {\n  color: #444444;\n}\n", ""]);

// exports
